/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selection_ClearInputs */

const en_selection_clear = /** @type {(inputs: Selection_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

const de_selection_clear = /** @type {(inputs: Selection_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl aufheben`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Selection_ClearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selection_clear = /** @type {((inputs?: Selection_ClearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selection_ClearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_selection_clear(inputs)
	return en_selection_clear(inputs)
});